<header class="app-header" vid="7">
    <div class="header-tabs" vid="8">
        <a href="#" class="tab active" vid="9">Routes</a>
        <a href="#" class="tab" vid="10">Drivers</a>
        <a href="#" class="tab" vid="11">Vehicles</a>
    </div>
    <div class="header-actions" vid="12">
        <div class="header-avatar"
            style="width: 24px; height: 24px; background: #333; border-radius: 50%; border: 1px solid #444; overflow: hidden; display: flex; justify-content: center; align-items: center;"
            vid="13">

            <div style="width: 100%; height: 100%; background: linear-gradient(135deg, #E24A4A, #111);" vid="14"></div>
        </div>
        <button class="btn" vid="15">
            <svg viewBox="0 0 24 24" vid="16">
                <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" vid="17"></path>
            </svg>
            Export
        </button>
        <button class="btn primary" vid="18">New Route</button>
    </div>
</header>

<main class="main-container" vid="19">

    <div class="toolbar" vid="20">
        <div class="filter-group" vid="21">
            <div class="search-wrapper" vid="22">
                <svg viewBox="0 0 24 24" vid="23">
                    <path
                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                        vid="24"></path>
                </svg>
                <input type="text" class="control-input" placeholder="Search routes..." vid="25">
            </div>

            <div class="divider" vid="26"></div>

            <span class="filter-label" vid="45">Status</span>
            <div class="control-wrapper" vid="27">
                <select class="control-input" vid="28" [(ngModel)]="params.status" placeholder="Status">
                    <option vid="29" [value]="'all'">Status: All</option>
                    <option vid="30" [value]="'active'">Active</option>
                    <option vid="31" [value]="'pending'">In Progress</option>
                    <option vid="32" [value]="'completed'">Completed</option>
                    <option vid="33" [value]="'cancelled'">Cancelled</option>
                </select>
                <svg class="select-icon" viewBox="0 0 24 24" vid="34">
                    <path d="M7 10l5 5 5-5z" vid="35"></path>
                </svg>
            </div>

            <span class="filter-label" vid="45">Driver</span>
            <div class="control-wrapper" vid="36">
                <ng-select [items]="drivers" bindLabel="name" bindValue="id" [virtualScroll]="true" [searchable]="true"
                    (scrollToEnd)="onScrollEnd()" (search)="onSearch($event)" [(ngModel)]="params.search"
                    placeholder="Select user">

                </ng-select>
                <svg class="select-icon" viewBox="0 0 24 24" vid="42">
                    <path d="M7 10l5 5 5-5z" vid="43"></path>
                </svg>
            </div>
        </div>

        <div class="filter-group" vid="44">
            <span class="filter-label" vid="45">Sort</span>
            <div class="control-wrapper" vid="46">
                <select class="control-input" style="min-width: 110px;" vid="47" [(ngModel)]="params.sort">
                    <option vid="48" [value]="'newest'">Date (Newest)</option>
                    <option vid="49" [value]="'oldest'">Date (Oldest)</option>
                    <option vid="50" [value]="'long'">Stops (High-Low)</option>
                    <option vid="50" [value]="'short'">Stops (High-Low)</option>

                </select>
                <svg class="select-icon" viewBox="0 0 24 24" vid="51">
                    <path d="M7 10l5 5 5-5z" vid="52"></path>
                </svg>
            </div>
        </div>
    </div>

    <div class="data-list-container" vid="53">
        <div class="list-header" vid="54">
            <div class="col-header" vid="55">Route Name</div>
            <div class="col-header" vid="56">Assigned Driver</div>
            <div class="col-header" vid="57">Date</div>
            <div class="col-header" vid="58">Stops</div>
            <div class="col-header" vid="59">Status</div>
            <div class="col-header" vid="60"></div>
        </div>

        <div class="list-row" *ngIf="page.totalItems === 0">
            <p>No Data</p>
        </div>

        <div class="list-row" vid="61" *ngFor="let route of page.data">
            <div class="cell cell-main" vid="62">{{ route.name }}</div>
            <div class="cell cell-sub" vid="63">{{ route.driver }}</div>
            <div class="cell cell-sub" vid="64">{{ route.created }}</div>
            <div class="cell cell-sub" vid="65">{{ route.deliveries.length }}</div>
            <div class="cell" vid="66">
                <div class="status-badge" vid="67">
                    <span class="status-dot active" vid="68"></span>
                    Active
                </div>
            </div>
            <div class="cell row-actions" vid="69">
                <button class="action-btn" vid="70"><svg viewBox="0 0 24 24" vid="71">
                        <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                            vid="72"></path>
                    </svg></button>
                <button class="action-btn" vid="73"><svg viewBox="0 0 24 24" vid="74">
                        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                            vid="75"></path>
                    </svg></button>
            </div>
        </div>


    </div>

    <div class="pagination" vid="136" *ngIf="page.totalItems > 0">
        <div class="page-info" vid="137">Showing {{ startIndex }} to {{ endIndex }} of {{ page.totalItems }} routes
        </div>
        <div class="page-controls" vid="138">
            <button class="page-btn" [disabled]="page.currentPage === 1" (click)="previousPage()">
                <svg viewBox="0 0 24 24" vid="140">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" vid="141"></path>
                </svg>
            </button>
            <ng-container *ngFor="let pageNum of pageNumbers">
                <button *ngIf="pageNum !== -1" class="page-btn" [class.active]="pageNum === page.currentPage"
                    (click)="goToPage(pageNum)">
                    {{ pageNum }}
                </button>

                <span *ngIf="pageNum === -1" style="pointer-events: none; border:none; background:none;">
                    ...
                </span>
            </ng-container>

            <button class="page-btn" [disabled]="page.currentPage === page.totalPages" (click)="nextPage()">
                <svg viewBox="0 0 24 24" vid="148">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" vid="149"></path>
                </svg>
            </button>
        </div>
    </div>

</main>